import React from 'react';
import { FaGlobe, FaHotel, FaUserTie, FaCogs, FaPlane, FaMapMarkedAlt, FaCar, FaPhone } from 'react-icons/fa';
import './OurServices.css';

const OurServices = () => {
  const services = [
    {
      id: 1,
      icon: <FaGlobe />,
      title: 'Delecious Meals',
      description: 'Enjoy freshly prepared breakfast and dinner included in every stay, featuring a variety of local cuisines.'
    },
    {
      id: 2,
      icon: <FaHotel />,
      title: 'Hotel Reservation',
      description: 'Best hotels and accommodations for your perfect stay anywhere in the India.'
    },
    {
      id: 3,
      icon: <FaUserTie />,
      title: 'Travel Guides',
      description: 'Expert local guides to enhance your travel experience with insider knowledge.'
    },
    {
      id: 4,
      icon: <FaCogs />,
      title: 'Tour managment',
      description: 'Professional event planning and management services for group and personal travels.'
    },
    {
      id: 5,
      icon: <FaPlane />,
      title: 'Travel Booking',
      description: 'Secure the best deals and comfortable travel arrangements all over india.'
    },
    {
      id: 6,
      icon: <FaMapMarkedAlt />,
      title: 'Custom Itineraries',
      description: 'Personalized travel plans designed specifically for your preferences and schedule.'
    },
    {
      id: 7,
      icon: <FaCar />,
      title: 'Transportation',
      description: 'Reliable transportation services including car rentals and private transfers.'
    },
    {
      id: 8,
      icon: <FaPhone />,
      title: '24/7 Support',
      description: 'Round-the-clock customer support to assist you throughout your journey.'
    }
  ];

  return (
    <section className="section our-services" id="services">
      <div className="container">
        <div className="section-title">
          
          <h2 className="section-heading">Our Services</h2>
        </div>
        
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurServices;